import { DEFAULT_EMPTY_VALUE } from "util/statHelpers";
import { UNSIGNED_CONTRACT_FILTER_STATUS } from "../services/ContractService";

export const blankContract: Contract = {
  contractNumber: 123,
  customerCode: DEFAULT_EMPTY_VALUE,
  customerName: DEFAULT_EMPTY_VALUE,
  amountDue: DEFAULT_EMPTY_VALUE,
  origins: undefined,
  destinations: undefined,
  poNumber: DEFAULT_EMPTY_VALUE,
  itemCode: DEFAULT_EMPTY_VALUE,
  productName: DEFAULT_EMPTY_VALUE,
  status: DEFAULT_EMPTY_VALUE,
  quantityShipped: 0,
  quantityShippedFormatted: DEFAULT_EMPTY_VALUE,
  quantityRemainingToOrder: 0,
  quantityRemainingToOrderFormatted: DEFAULT_EMPTY_VALUE,
  quantityTotal: 0,
  quantityTotalFormatted: DEFAULT_EMPTY_VALUE,
  quantityOnOrderOpen: 0,
  quantityOnOrderOpenFormatted: DEFAULT_EMPTY_VALUE,
  unitOfMeasure: "",
  shipStartDate: DEFAULT_EMPTY_VALUE,
  shipEndDate: DEFAULT_EMPTY_VALUE,
  currency: "",
};

export const blankUnsignedContract: Contract = {
  contractNumber: 123,
  customerCode: DEFAULT_EMPTY_VALUE,
  customerName: DEFAULT_EMPTY_VALUE,
  amountDue: DEFAULT_EMPTY_VALUE,
  origins: undefined,
  destinations: undefined,
  poNumber: DEFAULT_EMPTY_VALUE,
  itemCode: DEFAULT_EMPTY_VALUE,
  productName: DEFAULT_EMPTY_VALUE,
  status: UNSIGNED_CONTRACT_FILTER_STATUS,
  quantityShipped: 0,
  quantityShippedFormatted: DEFAULT_EMPTY_VALUE,
  quantityRemainingToOrder: 0,
  quantityRemainingToOrderFormatted: DEFAULT_EMPTY_VALUE,
  quantityTotal: 0,
  quantityTotalFormatted: DEFAULT_EMPTY_VALUE,
  quantityOnOrderOpen: 0,
  quantityOnOrderOpenFormatted: DEFAULT_EMPTY_VALUE,
  unitOfMeasure: "",
  shipStartDate: DEFAULT_EMPTY_VALUE,
  shipEndDate: DEFAULT_EMPTY_VALUE,
  currency: "",
  esignLink: "https://www.google.com",
};

export const contractTerms: ContractTerms = [
  {
    docEntry: 0,
    shipFrom: DEFAULT_EMPTY_VALUE,
    shipTo: DEFAULT_EMPTY_VALUE,
    mode: DEFAULT_EMPTY_VALUE,
    salesTerms: DEFAULT_EMPTY_VALUE,
    price: DEFAULT_EMPTY_VALUE,
    priceUnit: DEFAULT_EMPTY_VALUE,
  },
];
